import React, { useState } from 'react';
import { configData } from "./Config";
import DrgImg from "../assests/drg.png";
import "./Grouper.css";
import InputComponent from './InputComponent';
import axiosInstance from '../../../../axiosInterceptor';
import moment from 'moment/moment';
import Output from './Output';

const Grouper = () => {
  const date = new Date();
  const initialData = {};

  const initializeFormData = () => {
    configData.forEach((field) => {
      if (field.type === 'text') {
        initialData[field.name] = '';
      }
      else if (field.type === 'number') {
        initialData[field.name] = ""
      } else if (field.type === 'date') {
        initialData[field.name] = ""
      } else if (field.type === 'select') {
        initialData[field.name] = "";
      } else if (field.type === 'multi-select') {
        initialData[field.name] = [];
      }
    });
    return initialData;
  };

  const [formData, setFormData] = useState(initializeFormData);
  const [ageInDays, setAgeInDays] = useState(0);
  const [ageInYears, setAgeInYears] = useState(0);
  const [drgValue, setDrgValue] = useState("")
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("")
  const [openOutputPage, setOpenOutputPage] = useState(false);
  const [outputData, setOutputdata] = useState([]);

  const evenFields = Math.ceil(configData.length / 2);
  let leftColumn = configData.slice(0, evenFields);
  let rightColumn = configData.slice(evenFields);

  const handleGrouperData = (e) => {
    const { name, value } = e.target;
    // const newValue = (name === 'agedays' || name === 'ageyears') ? value && !isNaN(value) ? parseFloat(value) : 0
    //   : numericalNames.includes(name)
    //       ? value && !isNaN(value) ? parseFloat(value) : ""
    //       : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === 'agedays') {
      setAgeInDays(value ? parseFloat(value) : 0);
      if (value) setAgeInYears(0);
    }
    if (name === 'ageyears') {
      setAgeInYears(value ? parseFloat(value) : 0);
      if (value) setAgeInDays(0);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = {};

    configData.forEach((field) => {
      const inputValue = formData[field.name];
      const numericalNames = ['sep_mode', 'hmv', 'los', 'adm_wt'];

      if (inputValue && (field.name === "adm_date" || field.name === "bir_date" || field.name === "sep_date")) {
        if (Object.prototype.toString.call(inputValue) === "[object Date]" && !isNaN(inputValue)) {
          const formattedDate = moment(inputValue).format("DD/MM/YYYY");
          result[field.name] = formattedDate;
        } else {
          result[field.name] = '';
        }
      }
      else if (field.name === 'agedays' || field.name === 'ageyears') {
        result[field.name] = inputValue && !isNaN(inputValue) ? parseFloat(inputValue) : 0;
      }
      else if (numericalNames?.includes(field.name)) {
        result[field.name] = inputValue && !isNaN(inputValue) ? parseFloat(inputValue) : "";
      }
      else if (field.label === "Additional Diagnosis" || field.label === "Interventions" || inputValue?.includes(',')) {
        const splitValues = inputValue.split(',').map((val) => val.trim());
        field.name.forEach((name, index) => {
          result[name] = splitValues[index] || '';
        });
      }
      else {
        result[field.name] = inputValue || "";
      }
    });

    const payload = {
      ...result,
      mhls: "",
      urgadm: "1",
    };
    
      try {
        const response = await axiosInstance.post("https://0dcaakjw2m.execute-api.ap-southeast-2.amazonaws.com/Grouper_processing", payload);
        setLoading(false);
        const { data } = response
        // console.log("data",data);
        setDrgValue(data.drg)
        const newData = Object.assign({}, payload, data);
        setOutputdata([newData]);
        if (!data.drg) {
          setError("Sorry, we could not generate the DRG value")
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    // setFormData(initializeFormData());
    // setAgeInDays(0);
    // setAgeInYears(0);
  };

  const resetHandleClick = () => {
    setFormData(initializeFormData());
    setAgeInDays(0);
    setAgeInYears(0);
    setDrgValue("");
    setError("")
  }

  const isFormValid = () => {
    const isAgeFields = formData.agedays || formData.ageyears;
    const isAllFieldsFilled = configData.every((field) => {
      if (field.name === "agedays" || field.name === "ageyears") {
        return true
      }
      const fieldValue = formData[field.name];
      if (field.type === 'select') {
        return fieldValue !== '';
      }
      if (field.type === 'multi-select') {
        return Array.isArray(fieldValue) && fieldValue.length > 0;
      }
      return fieldValue !== '';
    });
    return isAgeFields && isAllFieldsFilled
  };

  const isFieldDisabled = (name) => {
    if (name === 'agedays') return ageInYears > 0;
    if (name === 'ageyears') return ageInDays > 0;
    return false;
  };



  return (
    <div className='main_section'>
      {!openOutputPage ? 
      <>
      <form onSubmit={handleSubmit}>
        <div className='fields-section'>
          <div className='sub_section' >
            {leftColumn.map((grouper) => (
              <InputComponent
                key={grouper.name}
                grouper={grouper}
                value={formData[grouper.name]}
                handleGrouperData={handleGrouperData}
                // error={errors[grouper.name]}
                // handleBlur={handleBlur}
                // disabled={isFieldDisabled(grouper.name)}
              />
            )
            )}
          </div>
          <div className='sub_section' >
            {rightColumn.map((grouper) => (
              <InputComponent
                key={grouper.name}
                grouper={grouper}
                value={formData[grouper.name]}
                handleGrouperData={handleGrouperData}
                // error={errors[grouper.name]}
                // handleBlur={handleBlur}
                // disabled={isFieldDisabled(grouper.name)}
              />
            )
            )}
          </div>

        </div>
        <div className='section_div'>
          <div className='drg_section'>
            <img src={DrgImg} alt='Drg Image' height="56" width="56" />
            <h6 className='drg_value'>AR-DRG is:  {(drgValue && drgValue?.length > 0) ? drgValue : (error ? error : "")}
            </h6>
          </div>
          <div>
            <button type="reset" className="reset-btn" onClick={resetHandleClick}>
              Reset
            </button>
            <button type='submit'
              // disabled={!isFormValid()}
              className='drg-btn'>{loading ? <span className='spinner-border' style={{
                width: "1rem", height: "1rem"
              }}></span> : "Generate DRG"}</button>
          </div>
        </div>
      </form>
      <div>
       {drgValue?.length > 0 &&  <button onClick={() => setOpenOutputPage(true)} className='output-btn'>Show OutPut</button>}
      </div>
      </>
: <Output openOutputPage={openOutputPage} setOpenOutputPage={setOpenOutputPage} outputData={outputData}/>
}
    </div>
  )
}
export default Grouper